import React, { useState } from 'react';
import './home.css';
import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';
import Header_img_Desktop from '../../assests/images/Header_img_Desktop.jpg';
import Virtual_exhibition from '../../assests/images/Virtual_exhibition.png';
import Vixr from '../../assests/images/Vixr.png';
import Features from '../../components/features/features';


const Home = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    return (
        <div>
            <Header />
            <section className="hero">
                <div className="hero-content">
                    <h2 className="hero-heading">Delivering Experience</h2>
                    <div className="hero-text">
                        <p>
                            Seventh August IT is a global business consulting and solutions integration company designing
                            specific solutions to businesses and offers services in the areas of software development and migration,
                            managed services and IT support, software product development and the like.
                        </p>
                        <p>
                            SAIT is a wholly owned Subsidiary of Nihilent Limited, a global IT Consulting and Solutions company.
                        </p>
                    </div>
                </div>
                <img src={Header_img_Desktop} alt="Happy man celebrating" className="hero-img" />
            </section>



            <section className="technology">
                <h3>Where ART meets TECHNOLOGY</h3>
                <p>SAIT operates <a href="https://www.artoreal.com" target="_blank" rel="noopener noreferrer">artoreal.com</a>
                    a web-to-wall e-commerce site
                    where customers and artists can register
                    to buy and sell high quality photographs, digital art, paintings and art prints with a mission to
                    Democratize Art for All, from art connoisseurs and high net-worth individuals to a wider target of home buyers and corporates.
                </p>
            </section>


            <Features />

            <section className="virtual-gallery">
                <h3>ViXR Helps you to...</h3>
                <div className="gallery">
                    <div className="image-container">
                        <img src={Vixr} alt="Virtual Art Gallery" className="full-image" />
                    </div>
                    <div className="image-container combined">
                        <img src={Virtual_exhibition} alt="Virtual Art Gallery" className="half-image" />
                        <button
                            className="explore-btn"
                            onClick={() => (window.location.href = "https://www.artoreal.com/3d-virtual-gallery")}
                        >
                            Experience Virtual Gallery
                        </button>

                    </div>
                </div>
            </section>


            <Footer />
        </div>
    )
}

export default Home;

